import Vue from 'vue';
export const globalStore = Vue.observable({
  web:JSON.parse(localStorage.getItem('web')) || null,
});

export const setStorage = (key, value) => {
  localStorage.setItem('web', JSON.stringify(value));
  globalStore[key] = value;
}